import React, { Component } from "react";
import PropTypes from "prop-types";

class LoadingButton extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleClick = () => {
    const { onClick } = this.props;
    if (!onClick) return;
    onClick();
  };

  render() {
    const { onlyDisable, isLoading, aditionalClass, label, type } = this.props;

    return (
      <>
        {isLoading ? (
          <button
            className={`btn btn-${aditionalClass} w-100`}
            disabled={true}
            type={"button"}
            // style={{ backgroundColor: "#212145" }}
          >
            <span
              translate="no"
              className="notranslate spinner-border lev-button-spinner"
              role="status"
              aria-hidden="true"
            ></span>
          </button>
        ) : (
          <button
            className={`btn btn-${aditionalClass} w-100`}
            disabled={onlyDisable}
            onClick={this.handleClick}
            type={type}
            // style={{ backgroundColor: "#212145" }}
          >
            {label}
          </button>
        )}
      </>
    );
    // return (
    //   <>
    //     <button
    //       className={`btn btn-${aditionalClass} w-100`}
    //       disabled={onlyDisable}
    //       onClick={this.handleClick}
    //       type={type}
    //     >
    //       {isLoading ? (
    //         <span   translate="no" className="notranslate spinner-border lev-button-spinner" role="status" aria-hidden="true"></span>
    //       ) :
    //       (<>{label}</>)
    //       }
    //     </button>
    //   </>
    // )
  }
}

LoadingButton.defaultProps = {
  aditionalClass: "primary",
  label: "Confirmar",
  onlyDisable: false,
  isLoading: false,
};

LoadingButton.propTypes = {
  aditionalClass: PropTypes.string,
  label: PropTypes.string,
  onlyDisable: PropTypes.bool,
  isLoading: PropTypes.bool,
};

export default LoadingButton;
